export default __webpack_public_path__ + "static/media/dustbin_icon.a951e45a.svg";